import script from "./recruitWillAuditApplyList.vue?vue&type=script&lang=ts&setup=true"
export * from "./recruitWillAuditApplyList.vue?vue&type=script&lang=ts&setup=true"

import "./recruitWillAuditApplyList.vue?vue&type=style&index=0&id=0f7a7554&lang=less"

const __exports__ = script;

export default __exports__